<template>
  <div class="content">
    <h1 class="title is-5">Последние обновленные показатели</h1>

    <div
      v-for="indicator in feed.slice(0, maxIndicators)"
      :key="indicator.id"
      class="m-b-md p-b-md row"
    >
      <span class="tag">{{ indicator.date | date }}</span> |
      <router-link :to="{name: 'indicator', params: {id: indicator.id}}" append>{{ indicator.name }}</router-link>
    </div>
    <div class="has-text-centered">
      <router-link
        :to="{name: 'indicators'}"
        class="button is-text is-small"
        append
      >Все показатели...</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    feed: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      maxIndicators: 10
    };
  }
};
</script>

<style scoped>
.content {
  font-size: 0.9rem;
}
.row {
  border-bottom: 1px solid #ddd;
}
</style>
